// @flow

export const CREATE_POST = 'CREATE_POST'
export const CREATE_TICKER = 'CREATE_TICKER'
export const POST_WAS_CREATED = 'POST_WAS_CREATED'
export const TICKER_WAS_CREATED = 'TICKER_WAS_CREATED'
export const POST_CREATING_ERROR = 'POST_CREATING_ERROR'
export const TICKER_CREATING_ERROR = 'TICKER_CREATING_ERROR'
export const POST_CREATING_RESET = 'POST_CREATING_RESET'
